module.exports = __webpack_public_path__ + "img/icons-bg.7830e14b.png";